import Api from '../../services/Api';

export default {
  state: {
    values: [],
    valuesLoaded: false,
  },
  actions: {
    loadValues({ commit }) {
      Api.getWebControls()
        .then(r => r.data)
        .then(values => {
          commit('SET_VALUES', values);
        })
        .catch(error => {
          this.$log.error(error);
        });
    },
  },
  mutations: {
    SET_VALUES(state, values) {
      state.values = values;
      state.valuesLoaded = true;
    },
  },
  getters: {
    getValueById: state => webControlId => {
      var result = webControlId;
      state.values.forEach(value => {
        if (value) {
          if (value.id === webControlId) {
            if (value.isActive && state.valuesLoaded) {
              result = value.ovalue;
            } else {
              result = '';
            }
          }
        }
      });
      return result;
    },
    isValuesLoaded: state => () => {
      return state.valuesLoaded;
    },
  },
};
